export default __webpack_public_path__ + "static/media/ic_users.708d4273.svg";